<template>

  <div>
    <PageHeader title="File Export" subtitle="Export Micro Notes to share or import at a later date"></PageHeader>

    <div class="main-content container-fluid xs-pt-0">
      <div class="row">
        <div class="col-xs-12">
          <Panel class="panel panel-default panel-border-color panel-border-color-primary">
            <PanelBody>
              <div v-if=" !subjects || !subjects.length">
                <p v-if=" !subjects"><LoadingIndicator></LoadingIndicator></p>
                <div v-else-if=" !subjects.length">
                  <p>
                    <br><em>You have no study material yet.</em>
                    <router-link :to="{name: 'importer'}">Upload your first Lecture Note now.</router-link>
                  </p>
                </div>
              </div>

              <!-- There is content to display -->
              <div v-else>
                <div v-for="subject in subjects">
                  <SubjectRow :subject="subject"></SubjectRow>
                </div>
              </div><!-- /.v-else -->

              <div class="button-bar">
                <button class="btn btn-primary btn-xl pull-right" @click.prevent="exportChapter" :disabled="microNotesForSelectedChapters.length <= 0 || status !== ''">{{status === '' ? 'Export file' : 'Exporting...'}}</button>
                <div class="active-toggle">
                  <span class="lbl">Include inactive micro notes:</span>
                  <BoolSwitch :toggle-bool="includeInactive" :toggle-function="toggleInactive" on-text="Yes" off-text="No"></BoolSwitch>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div><!-- /.div -->
</template>
<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import BoolSwitch from '../shared/controls/BoolSwitch'
  import SubjectRow from './SubjectRow'
export default {
    components: {
      BoolSwitch,
      SubjectRow
  },
  created() {
    this.getSubjects();
    this.getChapters();
    this.getMicroNotes();
  },
  methods: {
    ...mapActions([
      'getSubjects',
      'getChapters',
      'getMicroNotes',
    ]),
    exportChapter() {
      const microNoteIds = this.microNotesForSelectedChapters;
      if (microNoteIds.length > 0) {
        this.status = 'exporting';
        var self = this;
        const date = new Date();
        const fileName = 'CLEX_LectureNotes_' + date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate();
        this.$store.dispatch('exportMicroNotes',
          {
            fileName: fileName,
            export: { micronote_ids: '[' + microNoteIds.toString() + ']' },
            callback: function(error) {
              self.status = '';
            }
          });
      }
    },
    toggleInactive(value) {
      this.includeInactive = value;
      this.$store.commit(`SET_INCLUDE_INACTIVE_MICRONOTES`, { includeInactive: value })
    }
  },
  data() {
    return {
      status: '',
    }
  },
  computed: {
    ...mapGetters({
      micronotes: 'allMicroNotes',
      subjects: 'allSubjects',
      includeInactive: 'includeInactiveMicroNotes',
      microNotesForSelectedChapters: 'microNotesForSelectedChapters'
    }),
    ...mapState([
      'currentUser',
    ]),
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .active-toggle {float:right;font-size:14px;margin-top:10px;margin-right:40px;}
</style>



// WEBPACK FOOTER //
// FileExporter.vue?74ee6f6d